export default "<h1 class=\"mt-4\">{{title}}</h1>\n<sb-breadcrumbs *ngIf=\"!hideBreadcrumbs\"></sb-breadcrumbs>\n"